/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import Spinner from "components/spinner/spinner";
import { LoaderState } from "behaviors/loader/state";
import { TimeoutError } from "api/errors";

interface LoaderProps {
  loader: LoaderState;
}

const Loader: React.SFC<LoaderProps> = ({ loader: { loading, error } }) => {
  if (loading) {
    return <Spinner message={t("common.loading")} />;
  }
  if (error) {
    if (error instanceof TimeoutError) {
      return (
        <React.Fragment>
          <p>{t("loginPage.messages.not_loading")}</p>
        </React.Fragment>
      );
    }
  }

  return <p>{t("loginPage.messages.unknown_error")}</p>;
};

export default Loader;
